import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../services/auth.service'
import { Constants, Colors } from '../../common/config/constants'
import { environment } from '../../../environments/environment'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  showTitle = false
  title = ''
  subtitle = ''
  legalOpen = false
  logo = Constants.loginBg ? Constants.logoBig : Constants.logo
  showVodafoneTitle = true
  loginBg = null

  @HostBinding('style.background-image')
  get loginBgStyle() {
    return this.loginBg
  }

  @HostBinding('class.has-login-bg')
  get hasLoginBg() {
    return !!this.loginBg
  }

  get isGroup() {
    return environment.vodafoneGroup
  }

  constructor(
    private router: Router,
    private auth: AuthenticationService,
    protected sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    if (this.auth.isLoggedIn()) {
      this.router.navigateByUrl('/')
      return
    }

    const gradient = `linear-gradient(to bottom, rgba(26, 30, 41, 0.4), ${Colors.colorN100})`
    this.loginBg =
      Constants.loginBg &&
      this.sanitizer.bypassSecurityTrustStyle(
        `${gradient}, url("${Constants.loginBg}")`,
      )

    const config = environment && (environment as any).frontConfig
    const showVodafoneTitle = config && config.showVodafoneTitle
    this.showVodafoneTitle =
      showVodafoneTitle === undefined ? true : showVodafoneTitle
    const title = config && config.title
    this.showTitle = !!title
    if (this.showTitle) {
      const titleSplitted = title.split('\n').map((s) => s.trim())
      this.title = titleSplitted[0]
      this.subtitle = titleSplitted[1]
    }
  }

  ngOnDestroy() {}

  signIn() {
    this.auth.login()
  }

  toggleLegal() {
    this.legalOpen = !this.legalOpen
  }
}
